/**
 * ebookBuilder — Ebooks (Material Didático PDF), BE módulo content.
 *
 * @since fase material-didático ebook (2026-07-16)
 */
import type { $Fetch } from 'ofetch';

import { HttpEbookGateway } from '@/infrastructure/http/HttpEbookGateway';
import {
  ListEbooks, CreateEbook, UpdateEbook, ArquivarEbook, BaixarEbook,
} from '@/application/usecase/EbookUseCaseImpl';

export function buildEbookSlice(httpClient: $Fetch) {
  const gateway = new HttpEbookGateway(httpClient);

  const useCases = {
    listEbooks: new ListEbooks(gateway),
    createEbook: new CreateEbook(gateway),
    updateEbook: new UpdateEbook(gateway),
    arquivarEbook: new ArquivarEbook(gateway),
    baixarEbook: new BaixarEbook(gateway),
  };

  return { useCases };
}
